import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

import { legalText20K } from 'lib/constants/legalTexts';
import { PangvNotice } from '../PangvNotice';

export const LegalExampleText = () => (
  <Box>
    <Typography variant="body2" sx={{ color: 'grey.900' }}>
      {legalText20K}
    </Typography>
    <PangvNotice sx={{ marginTop: 2, marginBottom: 1 }} />
  </Box>
);
